module.exports = __webpack_public_path__ + "img/chart-top.dfceea51.svg";